export const validateMentorFormFeilds = (formFields) => {
    let formValidationErrors = [];
    
    for(let key in formFields){
        if(key === 'email'){
            if(!/[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})/.test(formFields[key])){
                formValidationErrors.push('Please enter a valid email');
            }
        }
        if(key === 'first_name'){
            if(formFields[key].length < 1){
                formValidationErrors.push(`Please enter a first name`);
            }
        }
        if(key === 'last_name'){
            if(formFields[key].length < 1){
                formValidationErrors.push(`Please enter a last name`);
            }
        }
        if(key === 'expertise'){
            if(formFields[key].length < 1){
                formValidationErrors.push(`Please enter a area of expertise`);
            }
        }
    }
 
    return formValidationErrors;
};

export const validateEmailAddress = (email) => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regex.test(email);
};


export const validateText = (text) => {
    return !!text;
};

export const validateContactUsFormFeilds = (formFields) => {
    let formValidationErrors = [];

    for(let key in formFields){
        if(key === 'email'){
            if(!/[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})/.test(formFields[key])){
                formValidationErrors.push('Please enter a valid email');
            }
        }
        if(key === 'first_name'){
            if(formFields[key].length < 1){
                formValidationErrors.push(`Please enter a first name`);
            }
        }
        if(key === 'last_name'){
            if(formFields[key].length < 1){
                formValidationErrors.push(`Please enter a last name`);
            }
        }
        if(key === 'message'){
            if(formFields[key].length < 1){
                formValidationErrors.push(`Please enter a message`);
            }
        }
    }

    return formValidationErrors;
};

export const validateWorkConfidenceFormFeilds = (formFields) => {
    let formValidationErrors = [];

    for(let key in formFields){
        if(key === 'email'){
            if(!/[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})/.test(formFields[key])){
                formValidationErrors.push('Please enter a valid email');
            }
        }
        if(key === 'first_name'){
            if(formFields[key].length < 1){
                formValidationErrors.push(`Please enter a first name`);
            }
        }
        if(key === 'last_name'){
            if(formFields[key].length < 1){
                formValidationErrors.push(`Please enter a last name`);
            }
        }
    }

    return formValidationErrors;
};
